import React, {useState} from "react";
import {
  Button,
  Card,
  CardText,
  CardTitle,
  Grid,
  TableColumn,
  SelectField,
  Cell,
  TextField,
} from "react-md";
import { CSVLink } from "react-csv";
import "../../css/mediaCss.css";
import Toggle from "react-toggle";
import { colorsArray, getColorsArrayDisPlayOrder, AngleDisplayOptions } from "./commonHelpers";
import { DEFAULT_VECTOR_SNAP_TO_GIRD, SymbolType } from "../../pages/AssignmentMatrix/Constants";
import LabelPositionFields from "./LabelPositionFields";
import { Chip, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Tooltip, TextField as MTextField } from "@mui/material";
import { IoAddCircle } from "react-icons/io5";
import { NotificationManager } from "react-notifications";
import { confirmAlert } from 'react-confirm-alert';
import trashIcon from '../../images/png/trashIcon.png';
import leftArrowIcon from '../../images/png/left-arrow.png';
import rigtArrowIcon from '../../images/png/right-arrow.png';
import ZeroAndSymbolVectorFields from "./ZeroAndSymbolVectorFields";
import SFVectorConfiguration from "./SFVectorConfiguration";
import SFVectorConfigurationCompact from "./SFVectorConfigurationCompact";
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import { PiCaretDown } from "react-icons/pi";
import ReactTooltip from "react-tooltip";

const ITEMS_PER_PAGE = 5;

const VariablesTable = (props) => {

  const [currentPage, setCurrentPage] = useState(0); // For paginating the vector icons
  const [activeVectorIndex, setActiveVectorIndex] = useState(0);

  const totalVectors = Array.from(props.data ? props.data.values() : []).length;
  const totalPages = Math.ceil(totalVectors / ITEMS_PER_PAGE);

  const [showVectorNameDialog, setShowVectorNameDialog] = useState(false);
  const [vectorName, setVectorName] = useState("");

  let isSnapToGrid = DEFAULT_VECTOR_SNAP_TO_GIRD;
  if (props.vectorSettingsData) {
    isSnapToGrid = !props.vectorSettingsData.isSnapToGridOff
  }

  const onVectorDeleteConfirm =(vectorObj) =>   {
      confirmAlert({
        title: 'Do you really want to delete this vector?',
        message: 'Press Confirm to submit',
  
        cancelLabel: 'Confirm',
        confirmLabel: 'Cancel',
        onCancel: () => {
          const deletedIndex = Array.from(props.data.keys()).indexOf(vectorObj.name);
          const newTotal = totalVectors - 1;
          props.onDeleteVector(vectorObj);

          if (newTotal <= 0) {
            setCurrentPage(0);
            setActiveVectorIndex(0);
            return;
          }

          const newActiveIndex = deletedIndex > 0 ? deletedIndex - 1 : 0;
          const newPage = Math.floor(newActiveIndex / ITEMS_PER_PAGE);
          setCurrentPage(newPage);
          setActiveVectorIndex(newActiveIndex);
        }
      });
  }

  return (
    <Card className={props.classNameString} style={{ marginLeft: "0px", marginBottom:'8px' }}>
      {/* Vector name dialog */}
      <Dialog open={showVectorNameDialog} maxWidth="xs" fullWidth>
          <DialogTitle>Vector name</DialogTitle>
          <DialogContent>
            <MTextField 
              placeholder="Enter vector name"
              fullWidth
              onChange={event => {
                setVectorName(event.target.value);
              }}
            />
          </DialogContent>
          <DialogActions>
            <Button primary flat  onClick={() => setShowVectorNameDialog(false)}>
              Cancel
            </Button>
            <Button primary raised onClick={() => {
              // check if vector name is unique from others
              let vectorKeysArr = Array.from(props.data.keys());
              if (vectorKeysArr.includes(vectorName)) {
                NotificationManager.error("Vector name already exists. Please give a different name", "", 3000);
                return
              }
              props.onAddQuestionVector(vectorName);
              const newIndex = totalVectors;
              const newPage = Math.floor(newIndex / ITEMS_PER_PAGE);
              setCurrentPage(newPage);
              setActiveVectorIndex(newIndex);
              setShowVectorNameDialog(false);
            }}>
              Add
            </Button>
          </DialogActions>
      </Dialog>
        
      <Accordion sx={{boxShadow:'none'}}>
        <AccordionSummary
          expandIcon={<PiCaretDown fontSize={24} />}
        >
          <div>
            <div style={{fontSize: '24px'}}>Vectors Configuration</div>
            <div style={{fontSize: '14px', color:'gray'}}>Edit vector variables used in the Question</div>
          </div>
        </AccordionSummary>
      

      <div style={{ display: "flex", alignItems:"center", margin:"0px 8px" }}>

        {/* Left arrow */}
        {
          currentPage !== 0 ?
            <Button
              style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
              disabled={currentPage === 0}
              onClick={() => {
                const newPage = currentPage - 1;
                setCurrentPage(newPage);
                setActiveVectorIndex(newPage * ITEMS_PER_PAGE);
              }}
            >
              <img src={leftArrowIcon} style={{ padding: '4px' }} alt="Prev" />
            </Button> : ""
        }

        {/* Show chips */}
        {Array.from(props.data.values())
          ?.slice(currentPage * ITEMS_PER_PAGE, (currentPage + 1) * ITEMS_PER_PAGE)
          ?.map((variableObj, i) => {
          const globalIndex = currentPage * ITEMS_PER_PAGE + i;
          let isActive = activeVectorIndex === globalIndex;
          return (
            <div key={globalIndex} style={{ position: 'relative', display: 'inline-block', marginRight: '8px' }}>
              <Chip
                size="medium"
                label={variableObj.name}
                variant={isActive ? 'filled' : 'outlined'}
                onClick={() => setActiveVectorIndex(globalIndex)}
                onDelete={() => {
                    if (variableObj.isStandaloneVector) {
                      // can delete
                      onVectorDeleteConfirm(variableObj)
                    }
                }}
                sx={{
                  cursor:'pointer',
                  fontSize: 14,
                  bgcolor: isActive ? '#bb0000' : undefined,
                  color: isActive ? '#fff' : undefined,
                  '&:hover': {
                    bgcolor: isActive ? '#bb0000' : undefined,
                  },
                  '& .MuiChip-deleteIcon': {
                    display: variableObj.isStandaloneVector ? 'block' : 'none',
                    color: isActive ? '#fff' : undefined,
                    '&:hover': {
                      color: isActive ? '#fff' : undefined,
                    },
                  },
                }}
              />
            </div>
          );
        })}

        {/* Right arrow */}
        {currentPage !== totalPages - 1 ?
            <Button
              style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
              disabled={currentPage === totalPages - 1}
              onClick={() => {
                const newPage = currentPage + 1;
                setCurrentPage(newPage);
                setActiveVectorIndex(newPage * ITEMS_PER_PAGE);
              }}
            >
              <img src={rigtArrowIcon} style={{ padding: '4px' }} alt="Next" />

            </Button> : 
          null}

        <ReactTooltip id='add-vector' type='dark' place='top' effect='solid'>
          Add Vector
        </ReactTooltip>
          <IconButton 
          data-tip data-for='add-vector'
          onClick={() => {
            if (props.onAddQuestionVector) {
              setShowVectorNameDialog(true);
            }
          }}>
            <IoAddCircle color="#bb0000" size={22} />
          </IconButton>
        
      </div>
      {/* <div className="section-break-line"></div> */}
      
      <CardText>
        {Array.from(props.data.values()).map((variableObj, i) => {
          if (i !== activeVectorIndex) return;
          const isCompValid = variableObj.inputType === "components" && (variableObj.variableType === "RANGE" || variableObj.variableType === "LIST" || variableObj.variableType === "RANGE CONTINUOUS" );
          const isAnglevalid = variableObj.inputType === "angle-magnitude" && (variableObj.variableType === "INT" || variableObj.variableType === "FLOAT" );
          
          return (
            <SFVectorConfigurationCompact 
                index={i}
                isSnapToGrid={isSnapToGrid}
                variableObj={variableObj}
                onTableRowChange={props.onTableRowChange}
            />
          )

          return (
            <Grid key={i}>
              {/* { i !== 0 && <div className="section-break-line"></div>} */}
              <Cell size={3}>
                <TextField
                  className=""
                  helpText={variableObj && variableObj.isStandaloneVector ? null : 
                    "This vector name cannot be edited here since its from question text."
                  }
                  disabled={variableObj && variableObj.isStandaloneVector ? false : true}
                  value={variableObj.name}
                  onChange={(value) => {
                    let newVectorName = value;
                    if (newVectorName === "") {
                      NotificationManager.error("Vector name cannot be empty", 3000);
                      return;
                    }
                    props.onTableRowChange(variableObj, newVectorName);
                  }}
                  label={"Vector"}
                  id={`text-field-${i}`}
                />
              </Cell>
              <Cell size={3}>
                {/* <TextField
                        className="textFieldClass"
                        value={variableObj.color}
                        label="Color"
                        id={`text-color-${i}`}
                        type="color"
                        onChange={(value) => {
                          variableObj.color = value;
                          props.onTableRowChange(variableObj);
                        }}
                        helpText="color hex values : #F79722, #0AAAFA, #FF5500, #09B83E, #34465D, #E4405F"
                      /> */}
                <SelectField
                  helpText="color hex values : #F79722, #0AAAFA, #FF5500, #09B83E, #34465D, #E4405F"
                  id={`text-color-${i}`}
                  label="Color"
                  fullWidth
                  onChange={(value) => {
                    variableObj.color = value;
                    props.onTableRowChange(variableObj);
                  }}
                  menuItems={colorsArray}
                  value={variableObj.color}
                />
              </Cell>
              <Cell size={3}>
                <SelectField
                  helpText="Select a vector input value type"
                  id={`variable-type-${i}`}
                  label="Type"
                  fullWidth
                  onChange={(value) => {
                    variableObj.inputType = value;
                    if (value === "components") {
                      variableObj.variableType = "RANGE";
                    } else {
                      variableObj.variableType = "INT";
                    }
                    
                    props.onTableRowChange(variableObj);
                  }}
                  menuItems={["components", "angle-magnitude"]}
                  value={variableObj.inputType}
                />
              </Cell>
              <Cell size={3}>
                {variableObj.inputType === "components" ? (
                  <SelectField
                    helpText="Select a vector variable type"
                    id={`variable-type1-${i}`}
                    label="Type"
                    onChange={(value) => {
                      if (value === "RANGE INTEGER") {
                        value = "RANGE"
                      }
                      variableObj.variableType = value;
                      props.onTableRowChange(variableObj);
                    }}
                    menuItems={isSnapToGrid ? ["RANGE INTEGER", "LIST"] : ["RANGE INTEGER", "RANGE CONTINUOUS", "LIST"]}
                    value={variableObj.variableType === "RANGE" ? "RANGE INTEGER" : variableObj.variableType}
                  />
                ) : (
                  <SelectField
                    helpText="Select a vector variable type"
                    id={`variable-type1-${i}`}
                    label="Type"
                    onChange={(value) => {
                      variableObj.variableType = value;
                      props.onTableRowChange(variableObj);
                    }}
                    menuItems={["INT", "FLOAT"]}
                    value={variableObj.variableType}
                  />
                )}
                {variableObj.isStandaloneVector ? 
                  <Button icon tooltipLabel="Delete"
                    style={{ marginLeft: "10px", marginBottom: "20px" }}
                    onClick={() => {
                      onVectorDeleteConfirm(variableObj)
                    }}>
                    <img src={trashIcon} alt="Delete" />
                  </Button>
                : null}
              </Cell>
              
              {(isCompValid || isAnglevalid) && <GetRow1 variableObj={variableObj} i={i} props={props} />}
              {(isCompValid || isAnglevalid) && <GetRow2 variableObj={variableObj} i={i} props={props} />}
              
              {/* ZeroAndSymbolVectorFields */}
              <ZeroAndSymbolVectorFields 
                index={i}

                latexSymbol={variableObj.latexSymbol}
                onLatexSymbolChange={(newValue) => {
                  variableObj.latexSymbol = newValue;
                  console.debug("variableObj>>??", variableObj)
                  props.onTableRowChange(variableObj);
                }}

                latexSymbolSize={variableObj.latexSymbolSize}
                onLatexSymbolSizeChange={(newValue) => {
                  variableObj.latexSymbolSize = newValue;
                  props.onTableRowChange(variableObj);
                }}

                zeroVectorPointRadius={variableObj.zeroVectorPointRadius}
                onChangeZeroVectorRadius={(newValue) => {
                  variableObj.zeroVectorPointRadius = newValue;
                  props.onTableRowChange(variableObj);
                }}

                zeroVectorPointColor={variableObj.zeroVectorPointColor}
                onChangeZeroVectorPointColor={(newValue) => {
                  variableObj.zeroVectorPointColor = newValue;
                  props.onTableRowChange(variableObj);
                }}
              />

              {variableObj.latexSymbol === SymbolType.IN_PLANE ? 
              <React.Fragment>
              <Cell size={2}>
                <label
                  htmlFor={`show-label-check-${i}`}
                  className="vectors-toggle-label"
                >
                  {"Show Label"}
                </label>
                <Toggle
                  icons={false}
                  width={230}
                  id={`show-label-check-${i}`}
                  name="Show Label"
                  onChange={(event) => {
                    variableObj.showLabel = event.target.checked;
                    props.onTableRowChange(variableObj);
                  }}
                  checked={variableObj.showLabel}
                />
              </Cell>
              

                {/* Label position fields For RP  */}
                  <LabelPositionFields 
                    id={i}
                    showLabel={variableObj.showLabel}
                    type={variableObj.labelPositionType ? variableObj.labelPositionType : "Automatic"}
                    onTypeChange={(newValue) => {
                        variableObj.labelPositionType = newValue;
                        props.onTableRowChange(variableObj);
                    }}
                    xValue={variableObj.labelPositionX ? variableObj.labelPositionX : variableObj.posX}
                    onXValueChange={(newValue) => {
                        variableObj.labelPositionX = newValue;
                        props.onTableRowChange(variableObj);
                    }}
                    yValue={variableObj.labelPositionY ? variableObj.labelPositionY : variableObj.posY}
                    onYValueChange={(newValue) => {
                        variableObj.labelPositionY = newValue;
                        props.onTableRowChange(variableObj);
                    }}
                  />

              <Cell size={2}>
                <label
                  htmlFor={`show-angle-check-${i}`}
                  className="vectors-toggle-label"
                >
                  {"Show Angle"}
                </label>
                <Toggle
                  icons={false}
                  width={230}
                  id={`show-angle-check-${i}`}
                  name="Show Angle"
                  onChange={(event) => {
                    variableObj.showAngle = event.target.checked;
                    props.onTableRowChange(variableObj);
                  }}
                  checked={variableObj.showAngle}
                  className="rp-fraction-checkbox"
                  label="Show Angle"
                />
              </Cell>
              <Cell size={2}>
                <label
                  htmlFor={`show-view-vectors-check-${i}`}
                  className="vectors-toggle-label"
                >
                  {"Show in Legend"}
                </label>
                <Toggle
                  icons={false}
                  width={230}
                  id={`show-view-vectors-check-${i}`}
                  name="Show in Legend"
                  onChange={(event) => {
                    variableObj.showLegend = event.target.checked;
                    props.onTableRowChange(variableObj);
                  }}
                  checked={(variableObj.showLegend !== null && variableObj.showLegend !== undefined) ? variableObj.showLegend : true}
                  className="rp-fraction-checkbox"
                  label="Show in Legend"
                />
              </Cell>
              {((variableObj.showLegend !== null && variableObj.showLegend !== undefined) ? variableObj.showLegend : true) ? 
              <Cell size={2}>
                <label
                  htmlFor={`show-default-checked-check-${i}`}
                  className="vectors-toggle-label"
                >
                  {"Default Checked"}
                </label>
                <Toggle
                  icons={false}
                  width={230}
                  id={`show-default-checked-check-${i}`}
                  name="Default Checked"
                  onChange={(event) => {
                    variableObj.defaultChecked = String(event.target.checked);
                    props.onTableRowChange(variableObj);
                  }}
                  checked={variableObj.defaultChecked !== null && variableObj.defaultChecked !== undefined && variableObj.defaultChecked !== "" ? variableObj.defaultChecked === "true" : true}
                  className="rp-fraction-checkbox"
                  label="Default Checked"
                />
              </Cell>
              : null }
              <Cell size={2}>
                <label
                  htmlFor={`show-components-check-${i}`}
                  className="vectors-toggle-label"
                >
                  {"Show Components"}
                </label>
                <Toggle
                  icons={false}
                  width={230}
                  id={`show-components-check-${i}`}
                  name="Show Components"
                  onChange={(event) => {
                    variableObj.showComponents = event.target.checked;
                    props.onTableRowChange(variableObj);
                  }}
                  checked={variableObj.showComponents}
                  className="rp-fraction-checkbox"
                  label="Show Components"
                />
              </Cell>
              <Cell size={3}>
                <label
                  htmlFor={`auto-origin-check-${i}`}
                  className="vectors-toggle-label"
                >
                  {"Auto Origin"}
                </label>
                <Toggle
                  icons={false}
                  width={230}
                  id={`auto-origin-check-${i}`}
                  name="Auto Origin"
                  onChange={(event) => {
                    variableObj.autoOrigin = event.target.checked;
                    props.onTableRowChange(variableObj);
                  }}
                  checked={variableObj.autoOrigin}
                  className="rp-fraction-checkbox"
                  label="Auto Origin"
                />
              </Cell>
              <br />
              <AngleOptions
                variableObj={variableObj}
                i={i}
                props={props}
                visible={variableObj.showAngle}
              />
              </React.Fragment>
              : null}
            </Grid>
          )
        })}
      </CardText>
      </Accordion>
    </Card>
  );
};

const ListValuesSection = (props) => {
  let variableObj = props.variableObj;
  let field = props.field;

  const csvData = [
    [
      "In column 1 enter the Question [variable] values",
      "In columns 2 through n enter the n correct answer value(s)",
    ],
    ["Australia", "Melbourne", "Sydney", "Perth"],
    ["India", "New Delhi", "Mumbai", "Chennai"],
    ["USA", "Columbus", "New York", "San Francisco"],
  ];
  return (
    <TableColumn>
      <TextField
        id="list-values"
        placeholder={props.placeholder}
        type="text"
        label={props.fieldName}
        value={variableObj[field] || ""}
        helpText={props.helpText}
        onChange={(value) => {
          variableObj[field] = value;
          props.onTableRowChange(variableObj);
        }}
      />
      {/*<FileInput onChange={ async (e) => {
              const reader = new FileReader()
              reader.onload = async (e) => { 
                const text = (e.target.result)
                console.log(text)
                alert(text)
              };
              reader.readAsText(e.target.files[0])
            }
        } id="answersCSV" label="Upload CSV File" accept="text/csv"></FileInput>
      <CSVLink filename="List_Question_Answer_template.csv" data={csvData}>
        Download Template
      </CSVLink>{" "}
      <input
        id="fileUpload"
        accept=".csv"
        type="file"
        onClick={(e) => {
          e.target.value = "";
        }}
        onChange={async (e) => {
          e.preventDefault();
          const reader = new FileReader();
          reader.onload = async (e) => {
            const entries = e.target.result?.split('"').join("").split("\n");
            let listValueFromFile;
            let listValueMap = new Map();
            for (const entry of entries) {
              if (entry !== "" && entry !== undefined && entry.length !== 0) {
                let answers = "";
                let row = entry.split(",");
                if (entries.indexOf(entry) === 0) {
                  listValueFromFile = row[0];
                } else {
                  listValueFromFile = listValueFromFile + "," + row[0];
                }
                for (const questAns of row) {
                  if (row.indexOf(questAns) !== 0) {
                    if (row.length <= 2) {
                      answers = questAns;
                    } else if (row.length > 2) {
                      if (answers === undefined || answers === "") {
                        answers = questAns;
                      } else {
                        answers = answers + "," + questAns;
                      }
                    }
                  }
                }
                listValueMap.set(row[0], answers);
              }
            }
            variableObj[field] = listValueFromFile;
            props.onTableRowChange(variableObj);
            props.onUploadFile(listValueMap);
          };
          reader.readAsText(e.target.files[0]);
        }}
      />  */}
    </TableColumn>
  );
};

const GetRow1 = ({variableObj, i, props}) => {

  const [errorXorigin,setErrorXorigin] = useState(false);
  const [xoriginHelperText,setXoriginHelperText] = useState('');
  const [errorXmin,setErrorXmin] = useState(false);
  const [xminHelperText,setXminHelperText] = useState('');
  const [errorXmax,setErrorXmax] = useState(false);
  const [xmaxHelperText,setXmaxHelperText] = useState('');
  const [errorMagmin,setErrorMagmin] = useState(false);
  const [magminHelperText,setMagminHelperText] = useState('');
  const [errorMagmax,setErrorMagmax] = useState(false);
  const [magmaxHelperText,setMagmaxHelperText] = useState('');

const getfirstInput = (type) => {
  return type === "components" ? "vectorBlackListX" : "vectorBlackListMagnitude";
}

const onXoriginChange = () => {
  if(variableObj.posX != ""){
  if(Number(variableObj.posX) < 0 || Number(variableObj.gridWidthUnit) <= Number(variableObj.posX)){
    setErrorXorigin(true);
    setXoriginHelperText(`Vector ${variableObj.name} is going outside the grid.`); 
  }else{
    setErrorXorigin(false);
    setXoriginHelperText('');
  }
 }
 onXmaxChange()
 onXminChange()
}

const onMagminChange = () => {
  if(variableObj.inputType === "angle-magnitude") {
    if(variableObj.magMin != ""){
      if(Number(variableObj.magMax) < Number(variableObj.magMin)) {
        setErrorMagmin(true);
        setMagminHelperText(`mag-min cannot be greater than mag-max`)
      }else{
        setErrorMagmin(false);
        setMagminHelperText('');
      } 
    }           
   }
}

const onMagmaxChange = () => {
  if(variableObj.inputType === "angle-magnitude") {
    if(variableObj.magMax != ""){
      if(Number(variableObj.magMax) < Number(variableObj.magMin)) {
        setErrorMagmax(true);
        setMagmaxHelperText(`mag-max cannot be less than mag-min`)
      }else{
        setErrorMagmax(false);
        setMagmaxHelperText('');
      } 
    }           
   }
}

const onXminChange = () => {
  if(variableObj.inputType === "components" && variableObj.variableType !== 'LIST') {
    if(variableObj.xMin != ""){
      if(Number(variableObj.xMax) < Number(variableObj.xMin)) {
        setErrorXmin(true);
        setXminHelperText(`x-min cannot be greater than x-max`)
      }else if(Number(variableObj.xMin) < -Number(variableObj.posX)){
        setErrorXmin(true);
        setXminHelperText(`Vector ${variableObj.name} is going outside the grid`)
      }
      else{
        setErrorXmin(false);
        setXminHelperText('');
      } 
    }           
   }
}

const onXmaxChange = () => {
  if(variableObj.inputType === "components" && variableObj.variableType !== 'LIST') {
    if(variableObj.xMax != ""){
      if(Number(variableObj.xMax) < Number(variableObj.xMin)) {
        setErrorXmax(true);
        setXmaxHelperText(`x-max cannot be less than x-min`)
      }else if(Number(variableObj.xMax) > Number(variableObj.gridWidthUnit - variableObj.posX)){
        setErrorXmax(true);
        setXmaxHelperText(`Vector ${variableObj.name} is going outside the grid`)
      }
      else{
        setErrorXmax(false);
        setXmaxHelperText('');
      } 
    }           
   }
}

  return (
    <React.Fragment>
        <Grid>
          <Cell size={3}>
              <TextField
                className="textFieldClass"
                error={errorXorigin}
                value={variableObj.posX ? variableObj.posX : ""}
                disabled={variableObj.autoOrigin}
                label="origin-x"
                type="number"
                id={`text-x-${i}`}
                onChange={(value) => {
                  variableObj.posX = value;
                  props.onTableRowChange(variableObj);
                  onXoriginChange();
                }}
                helpText={errorXorigin ? xoriginHelperText:"x component of vector "}
              />
            </Cell>
            {variableObj.latexSymbol === SymbolType.IN_PLANE ? 
              (variableObj.inputType === "components" ? (
                <>
                {variableObj.variableType === "RANGE" || variableObj.variableType === "RANGE CONTINUOUS" ? (
                  <React.Fragment>
                    <Cell size={3}>
                      <TextField
                        className="textFieldClass"
                        error={errorXmin}
                        value={variableObj.xMin}
                        label="x-min"
                        type="number"
                        id={`text-x-${i}`}
                        onChange={(value) => {
                          variableObj.xMin = value;
                          props.onTableRowChange(variableObj);
                          onXminChange();
                          onXmaxChange();
                        }}
                        helpText={errorXmin ? xminHelperText:"x component of vector "}
                      />
                    </Cell>
                    <Cell size={3}>
                      <TextField
                        className="textFieldClass"
                        error={errorXmax}
                        value={variableObj.xMax}
                        label="x-max"
                        type="number"
                        id={`text-x-${i}`}
                        onChange={(value) => {
                          variableObj.xMax = value;
                          props.onTableRowChange(variableObj);
                          onXmaxChange();
                          onXminChange();
                        }}
                        helpText={errorXmax ? xmaxHelperText:"x component of vector "}
                      />
                    </Cell>
                  </React.Fragment>
                ) : <ListValuesSection 
                      variableObj={variableObj}
                      field="xList"
                      fieldName="List for X"
                      placeholder='Enter list values seperated by comma " , " '
                      helpText="Enter values seperated by comma eg: 1,2.5,3,4,5"
                      onTableRowChange={props.onTableRowChange}
                />}
                </>
              ): (
                <>
                <Cell size={3}>
                  <TextField
                    className="textFieldClass"
                    error = {errorMagmin}
                    value={variableObj.magMin}
                    label="mag-min"
                    type="number"
                    id={`mag-min-${i}`}
                    onChange={(value) => {
                      variableObj.magMin = value;
                      props.onTableRowChange(variableObj);
                      onMagminChange();
                    }}
                    helpText={errorMagmin ? magminHelperText:"magnitude of vector "}
                  />
                </Cell>
                <Cell size={3}>
                  <TextField
                    className="textFieldClass"
                    error = {errorMagmax}
                    value={variableObj.magMax}
                    label="mag-max"
                    type="number"
                    id={`mag-max-${i}`}
                    onChange={(value) => {
                      variableObj.magMax = value;
                      props.onTableRowChange(variableObj);
                      onMagmaxChange();
                    }}
                    helpText={errorMagmax ? magmaxHelperText:"magnitude of vector "}
                  />
                </Cell>
                </>
              ))
            : null}

            {variableObj.latexSymbol === SymbolType.OUT_ODOT || variableObj.latexSymbol === SymbolType.IN_OTIMES ? 
              <React.Fragment>
                 <Cell size={3}>
                      <TextField
                        className="textFieldClass"
                        value={variableObj.zMin}
                        label="z-min"
                        type="number"
                        id={`text-z-${i}`}
                        onChange={(value) => {
                          variableObj.zMin = value;
                          props.onTableRowChange(variableObj);
                        }}
                      />
                    </Cell>
                    <Cell size={3}>
                      <TextField
                        className="textFieldClass"
                        error={errorXmax}
                        value={variableObj.zMax}
                        label="z-max"
                        type="number"
                        id={`text-x-${i}`}
                        onChange={(value) => {
                          variableObj.zMax = value;
                          props.onTableRowChange(variableObj);
                        }}
                      />
                    </Cell>
              </React.Fragment>
            : null }
              
            {variableObj.latexSymbol === SymbolType.IN_PLANE ? 
            (variableObj.variableType === "RANGE" || variableObj.variableType === "RANGE CONTINUOUS") || (variableObj.inputType === "angle-magnitude") ? (
                <React.Fragment>
                  <Cell size={3}>
                    <TextField
                      id="text-black-list-x"
                      label={`Excluded List for ${variableObj.inputType === "components" ? "X" : "magnitide"}`}
                      placeholder="Multiple values must be comma separated"
                      type="text"
                      helpText="Multiple values must be comma separated"
                      onChange={(value) => {
                        variableObj[getfirstInput(variableObj.inputType)] = value;
                        props.onTableRowChange(variableObj);
                      }}
                      value={variableObj[getfirstInput(variableObj.inputType)] || ""}
                    />
                  </Cell>
                </React.Fragment>
              ) : null
              : null}

        </Grid>
      </React.Fragment>
  )
};

const GetRow2 = ({variableObj, i, props}) => {
  
  const [errorYorigin,setErrorYorigin] = useState(false);
  const [yoriginHelperText,setYoriginHelperText] = useState('');
  const [errorYmin,setErrorYmin] = useState(false);
  const [yminHelperText,setYminHelperText] = useState('');
  const [errorYmax,setErrorYmax] = useState(false);
  const [ymaxHelperText,setYmaxHelperText] = useState('');
  const [errorAngmin,setErrorAngmin] = useState(false);
  const [angminHelperText,setAngminHelperText] = useState('');
  const [errorAngmax,setErrorAngmax] = useState(false);
  const [angmaxHelperText,setAngmaxHelperText] = useState('');

  const getsecondInput = (type) => {
    return type === "components" ? "vectorBlackListY" : "vectorBlackListAngle";
  } 

  const onYoriginChange = () => {
    if(variableObj.posY != ""){
    if(Number(variableObj.posY) < 0 || Number(variableObj.gridHeightUnit) <= Number(variableObj.posY)){
      setErrorYorigin(true);
      setYoriginHelperText(`Vector ${variableObj.name} is going outside the grid.`); 
    }else{
      setErrorYorigin(false);
      setYoriginHelperText('');
    }
   }
    onYmaxChange()
    onYminChange()
  }

  const onAngminChange = () => {
    if(variableObj.inputType === "angle-magnitude") {
      if(variableObj.angleMin != ""){
        if(Number(variableObj.angleMax) < Number(variableObj.angleMin)) {
          setErrorAngmin(true);
          setAngminHelperText(`angle-min cannot be greater than angle-max`)
        }else{
          setErrorAngmin(false);
          setAngminHelperText('');
        } 
      }           
     }
  }
  
  const onAngmaxChange = () => {
    if(variableObj.inputType === "angle-magnitude") {
      if(variableObj.angleMax != ""){
        if(Number(variableObj.angleMax) < Number(variableObj.angleMin)) {
          setErrorAngmax(true);
          setAngmaxHelperText(`angle-max cannot be less than angle-min`)
        }else{
          setErrorAngmax(false);
          setAngmaxHelperText('');
        } 
      }           
     }
  }

  const onYminChange = () => {
    if(variableObj.inputType === "components" && variableObj.variableType !== 'LIST') {
      if(variableObj.yMin != ""){
        if(Number(variableObj.yMax) < Number(variableObj.yMin)) {
          setErrorYmin(true);
          setYminHelperText(`y-min cannot be greater than y-max`)
        }else if(Number(variableObj.yMin) < -Number(variableObj.posY)){
          setErrorYmin(true);
          setYminHelperText(`Vector ${variableObj.name} is going outside the grid`)
        }
        else{
          setErrorYmin(false);
          setYminHelperText('');
        } 
      }           
     }
  }
  
  const onYmaxChange = () => {
    if(variableObj.inputType === "components" && variableObj.variableType !== 'LIST') {
      if(variableObj.yMax != ""){
        if(Number(variableObj.yMax) < Number(variableObj.yMin)) {
          setErrorYmax(true);
          setYmaxHelperText(`y-max cannot be less than y-min`)
        }else if(Number(variableObj.yMax) > Number(variableObj.gridHeightUnit - variableObj.posY)){
          setErrorYmax(true);
          setYmaxHelperText(`Vector ${variableObj.name} is going outside the grid`)
        }
        else{
          setErrorYmax(false);
          setYmaxHelperText('');
        } 
      }           
     }
  }
 
  return (
    <React.Fragment>
        <Grid>
          
            <Cell size={3}>
              <TextField
                className="textFieldClass"
                error ={errorYorigin}
                disabled={variableObj.autoOrigin}
                value={variableObj.posY ? variableObj.posY : ""}
                label="origin-y"
                type="number"
                id={`text-y-${i}`}
                onChange={(value) => {
                  variableObj.posY = value;
                  props.onTableRowChange(variableObj);
                  onYoriginChange();
                }}
                helpText={errorYorigin ? yoriginHelperText:"y component of vector "}
              />
            </Cell>
            {variableObj.latexSymbol === SymbolType.IN_PLANE ? 
            variableObj.inputType === "components" ? (
              <>
              {variableObj.variableType === "RANGE" || variableObj.variableType === "RANGE CONTINUOUS" ? (
                  <React.Fragment>
                  <Cell size={3}>
                    <TextField
                      className="textFieldClass"
                      error={errorYmin}
                      value={variableObj.yMin}
                      label="y-min"
                      type="number"
                      id={`text-y-${i}`}
                      onChange={(value) => {
                        variableObj.yMin = value;
                        props.onTableRowChange(variableObj);
                        onYminChange();
                        onYmaxChange();
                      }}
                      helpText={errorYmin ? yminHelperText:"y component of vector "}
                    />
                  </Cell>
                  <Cell size={3}>
                    <TextField
                      className="textFieldClass"
                      error={errorYmax}
                      value={variableObj.yMax}
                      label="y-max"
                      type="number"
                      id={`text-y-${i}`}
                      onChange={(value) => {
                        variableObj.yMax = value;
                        props.onTableRowChange(variableObj);
                        onYmaxChange();
                        onYminChange();
                      }}
                      helpText={errorYmax ? ymaxHelperText:"y component of vector "}
                    />
                  </Cell>
                  </React.Fragment>
                ) : <ListValuesSection 
                        variableObj={variableObj}
                        field="yList"
                        fieldName="List for Y"
                        placeholder='Enter list values seperated by comma " , " '
                        helpText="Enter values seperated by comma eg: 1,2.5,3,4,5"
                        onTableRowChange={props.onTableRowChange}
                  />}
              </>) : (<>
                <Cell size={3}>
                  <TextField
                    className="textFieldClass"
                    error={errorAngmin}
                    value={variableObj.angleMin}
                    label="angle-min"
                    type="number"
                    id={`angle-min-${i}`}
                    onChange={(value) => {
                      variableObj.angleMin = value;
                      props.onTableRowChange(variableObj);
                      onAngminChange();
                    }}
                    helpText={errorAngmin ? angminHelperText:"angle component of vector"}
                  />
                </Cell>
                <Cell size={3}>
                  <TextField
                    className="textFieldClass"
                    error={errorAngmax}
                    value={variableObj.angleMax}
                    label="angle-max"
                    type="number"
                    id={`angle-max-${i}`}
                    onChange={(value) => {
                      variableObj.angleMax = value;
                      props.onTableRowChange(variableObj);
                      onAngmaxChange();
                    }}
                    helpText={errorAngmax ? angmaxHelperText:"angle component of vector"}
                  />
                </Cell>
              </>
            )
            : null}

          {variableObj.latexSymbol === SymbolType.IN_PLANE ? 
          (variableObj.variableType === "RANGE" || variableObj.variableType === "RANGE CONTINUOUS") || (variableObj.inputType === "angle-magnitude") ? (
                <React.Fragment>
                  <Cell size={3}>
                    <TextField
                      id="text-black-list-y"
                      label={`Excluded List for ${
                        variableObj.inputType === "components" ? "Y" : "angle"
                      }`}
                      placeholder="Multiple values must be comma separated"
                      type="text"
                      helpText="Multiple values must be comma separated"
                      onChange={(value) => {
                        variableObj[getsecondInput(variableObj.inputType)] = value;
                        props.onTableRowChange(variableObj);
                      }}
                      value={variableObj[getsecondInput(variableObj.inputType)] || ""}
                    />
                  </Cell>
                </React.Fragment>
              ) : null
              : null}
          </Grid>
      </React.Fragment>
  )
};

const AngleOptions = ({ variableObj, i, props, visible }) => {
  let angleOptions = variableObj ? variableObj.angleOptions : {};
  if (!angleOptions) {
    {
      angleOptions = {};
    }
  }

  const getHelpText = () => {
    return <p className="custom-tooltip-text">{
      AngleDisplayOptions.map((array, index) => {
        return (<p>Option{index + 1}: {array.label}</p>)
      })}
    </p>
  }

  if (visible) {
    return (
      <React.Fragment>
        <Grid>
          <Cell size={4}>
            <SelectField
              helpText="Select a Angle Display Option"
              id={`angle-option-${i}`}
              label="Angle Display Options"
              onChange={(value) => {
                angleOptions = { ...angleOptions, type: value };
                variableObj.angleOptions = angleOptions;
                props.onTableRowChange(variableObj);
              }}
              menuItems={[1, 2, 3]}
              value={angleOptions.type}
            />
            <Button
              className="nocqcStyle"
              icon
              tooltipLabel={getHelpText()}
            >
              help
            </Button>
          </Cell>
          <Cell size={4}>
            <TextField
              id={`angle-offset-${i}`}
              label="angle offset from base angle"
              placeholder="Offset Angle"
              type="number"
              helpText="The base angle is with reference to x axis, change offset value to change it"
              onChange={(value) => {
                angleOptions = {
                  ...angleOptions,
                  angleOffset: value ? parseFloat(value): '',
                };
                variableObj.angleOptions = angleOptions;
                props.onTableRowChange(variableObj);
              }}
              value={angleOptions.angleOffset}
            />
          </Cell>
          <Cell size={4}>
            <label
              htmlFor={`show-angle-clockwise-${i}`}
              className="vectors-toggle-label"
            >
              {"Angle Direction Clockwise"}
            </label>
            <Toggle
              icons={false}
              width={230}
              id={`show-angle-clockwise-${i}`}
              name="Angle Direction"
              onChange={(event) => {
                angleOptions = {
                  ...angleOptions,
                  clockwise: event.target.checked,
                };
                variableObj.angleOptions = angleOptions;
                props.onTableRowChange(variableObj);
              }}
              checked={angleOptions.clockwise}
            />
          </Cell>
        </Grid>
      </React.Fragment>
    );
  } else {
    return null;
  }
};

export default VariablesTable;

export const createEmptyVectorAnswerFormula = (index) => {
  return {
    name: "",
    formulaType: "components",
    angleFormula: "",
    formulaColor: "#000000", //getColorsArrayDisPlayOrder(index),
    magFormula: "",
    xFormula: "",
    yFormula: "",
    posX: "0",
    posY: "0",
    showComponents: false,
    xOrigin: "5",
    yOrigin: "5",
    autoOrigin: true,
    snapToGrid: "true",
    evaluate_x: 0, // 0 means true, so by default when vector answer formula is created evaluate x and y is toggled ON
    evaluate_y: 0, // 0 means true
    evaluate_angle: 0,
    evaluate_magnitue: 0,
  };
};

export const VectorQuestionHelp = function (props) {

  const [showOldHelp, setShowOldHelp] = useState(false);

  return (
    <div className="image-resize-warning RTWrapper" key="help-text-1">
      <p>
        <b>Help :</b>
      </p>
        <ol style={{ display: "flex", flexDirection: "column", gap: "5px", color:"#808080", fontSize:'13px' }}>
          <li>
            To create one or more vectors (that can be made visible on the grid),
            use the Vectors Configuration box below. The vectors can have
            values randomly chosen from a specified range.
          </li>

          <li>
            In the question box above, you can refer to a created vector by using
            LaTeX (e.g., $\vec&#123;A&#125;$, if the label in the Vectors
            Configuration is “\vec&#123;A&#125;”).
          </li>

          <li>
            To show the values of the vector in the question box, use:
            \eval&#123;\vec&#123;A&#125;_x&#125;,{" "}
            \eval&#123;\vec&#123;A&#125;_y&#125;,{" "}
            \eval&#123;\vec&#123;A&#125;_z&#125;,{" "}
            \eval&#123;\vec&#123;A&#125;_magnitude&#125; or \eval&#123;\vec&#123;A&#125;_mag&#125;,{" "}
            \eval&#123;\vec&#123;A&#125;_angle&#125; or \eval&#123;\vec&#123;A&#125;_ang&#125;
          </li>

          <li>
            Example:
            What is the magnitude of $\vec&#123;A&#125;$, which has an
            x-component of{" "}
            \eval&#123;\vec&#123;A&#125;_x&#125; and a y-component of{" "}
            \eval&#123;\vec&#123;A&#125;_y&#125;?
          </li>
        </ol>

        {/* Toggle inside box */}
        <p
          style={{
            cursor: "pointer",
            color: "#666",
            fontSize: "12px",
            marginTop: "8px",
            marginBottom: "4px",
          }}
          onClick={() => setShowOldHelp(!showOldHelp)}
        >
          {showOldHelp ? "Hide deprecated format ▲" : "Show deprecated format ▼"}
        </p>

        {/* Old Help (collapsible) */}
        {showOldHelp && (
          <div
            style={{
              borderTop: "1px dashed #ccc",
              paddingTop: "8px",
              opacity: 0.75,
            }}
          >
            <p><b>Deprecated :</b></p>

            <p>
              Enter vector variable names inside square bracket '[]'. To
              use latex mode, you must use $[ ]$
              <br />
              Eg 1: What is $[\vec&#123;A&#125;]$ $+$ $[\vec&#123;B&#125;]$?
              <br />
              Eg 2: What is the magntidue of $[\vec&#123;A&#125;]$, which has an x-component of \eval&#123;\vec&#123;A&#125;_x&#125; and an y-component of \eval&#123;\vec&#123;A&#125;_y&#125;.


              <div>
                <br />
                <b>To show value's of the vector: </b>  
                <code>\eval&#123;\vec&#123;A&#125;_x&#125;</code>,{" "}
                <code>\eval&#123;\vec&#123;A&#125;_y&#125;</code>,{" "}
                <code>\eval&#123;\vec&#123;A&#125;_z&#125;</code>,{" "}
                <code>\eval&#123;\vec&#123;A&#125;_mag&#125;</code>,{" "}
                <code>\eval&#123;\vec&#123;A&#125;_angle&#125;</code>
                
              </div>
            </p>

          </div>
        )}
    </div>
  )

};